module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-1-photo-2-d1fb74836449848f8672ad807b558b6f.webp";